import dayjs from 'dayjs';
import { ICopyWithBusinessRef } from '../contracts/copy-with-business-ref.js';
import { DataModel } from './dto/dto.js';
import { BusinessModuleRef } from './serializable/business-module-ref.js';

export enum RedeemableCodeStatus {
    Live = 'LIVE',
    Used = 'USED'
}

export abstract class ISingleUseRedeemableCode {
    abstract get usedBy(): string | null
    abstract get usedAt(): dayjs.Dayjs | null
    abstract get status(): RedeemableCodeStatus
}

export abstract class RedeemableCode extends DataModel implements ICopyWithBusinessRef {
    abstract get uniqueId(): string
    abstract get businessRef(): BusinessModuleRef
    abstract get creationDate(): dayjs.Dayjs
    abstract get expirationDate(): dayjs.Dayjs | null
    abstract copyWithBusinessRef(businessRef: BusinessModuleRef): this;
}
